<template>
  <loader v-bind="{ loading }">
    <page-navigation :title="`Teams (${teams.total})`">
      <template #right>
        <search-bar
          v-model="filters.search"
          @run-search="search"
          @clear-search="clearSearch">
          <template #buttons>
            <router-link
              :to="{ name: 'create-team' }"
              class="is-rounded button">
              <icon icon="plus"/>
              <span>Team</span>
            </router-link>
          </template>
        </search-bar>
      </template>
    </page-navigation>  

    <columns>
      <column>
        <index-row
          v-for="team in teams.data" :key="team.id"
          :title="team.name"
          :route="{ name: 'team-manager', params: { team: team.id }}">
            <span class="help">last active {{ team.updated_at | asCalendar }}</span>
            <template #right>
              <flex width="10%" min-width="100px" class="align-center" column>
                <p>{{ team.members_count }}</p>
                <p>Members</p>
              </flex>
              <flex width="10%" min-width="100px" class="align-center" column>
                <p>{{ team.apps_count }}</p>
                <p>Apps</p>
              </flex>
            </template>
        </index-row>  

        <pager v-if="teams.next_page_url || teams.prev_page_url" context="team" :pageable="teams" @nav="goTo"/>
        
        <no-items-to-show v-if="!teams.data.length" text="No Teams Found">
          <router-link
            :to="{ name: 'create-team' }"
            class="is-rounded button">
            <icon icon="plus"/>
            <span>Create a Team</span>
          </router-link>
        </no-items-to-show>  

      </column>
    </columns>
  </loader>
</template>

<script>
import { getPath } from '@/api/common'
import Paginator from '@/store/models/Paginator'

export default {

  name: 'Teams',

  data: () => ({
    teams: new Paginator,
    loading: true,
    searching: false,
    filters: {
      search: ''
    }
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'Teams')
  },

  created() {
    if (this.$route.query.search) {
      this.filters.search = this.$route.query.search
    }
    this.loadTeams()
  },

  methods: {
    loadTeams() {
      getPath({
        path: 'api' + this.$route.fullPath
      }, ({ data }) => {
        this.teams = data
        this.loading = false
      })
    },
    goTo(path) {
      this.$router.push(path)
    },
    search() {
      if (!this.filters.search.length) {
        this.$toast.warning('Please enter a search phrase')
        return
      }
      this.$router.push({
        name: 'teams',
        query: {
          search: this.filters.search
        }
      })
    },
    clearSearch() {
      this.filters.search = ''
      this.$router.push({
        name: 'teams',
        query: {}
      })
    }
  },

  watch: {
    '$route': 'loadTeams'
  }
}
</script>
